﻿/*

--------------------------------------------------------------------------------
Custom textarea widget using some Kendo-style functionality.
Provides textarea with placeholder also for browsers which don't support it,
validation and tooltip popup icons and applying similar component status behavior
as in native Kendo UI widgets.
When the browser doesn't support placeholders, there is a separate label generated
under the main input, which is shown only when the main input is empty. Same
.placeholder CSS class is applied as for other widgets, so styling should be
reasonably easy.
For base functionality see ori.kendo.textbox.js.
For tooltips and validation implementation see ori.kendo.tooltip.js
and ori.kendo.validator.js.
--------------------------------------------------------------------------------

<![CDATA[

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo,
        ui = kendo.ui,
        TextBox = ui.TextBox,
        AVATAR = "avatar",
        SCROLLBAR = "has-scrollbar",
        NS = ".kendoTextArea";

    var TextArea = TextBox.extend({

        init: function (element, options) {
            var self = this;
            self.ns = self.ns || NS;
            TextBox.fn.init.call(self, element, options);
            self.element.attr("role", "textarea");
            self._hasScrollbar();
            kendo.notify(self);
        },

        options: {
            name: "TextArea"
        },

        _hasScrollbar: function () {
            var self = this,
                $wrapper = self.wrapper,
                elem = self.element[0],
                scrollbar = (elem.clientHeight < elem.scrollHeight);
            $wrapper[scrollbar ? "addClass" : "removeClass"](SCROLLBAR);
            self.info(
                "%s - - -  clientHeight = %s, scrollHeight = %s",
                (scrollbar ?
                    "The element has a vertical scrollbar !" :
                    "The element doesn't have a vertical scrollbar."),
                elem.clientHeight, elem.scrollHeight
            );
        },

        _keyup: function () {
            var self = this;
            self._placeholder(!kendo.toString(self.element.val()));
            self._hasScrollbar();
        },

        _update: function (value) {
            var self = this;
            self._value = value;
            self._placeholder(!kendo.toString(value));
            self.element
                .val(value.toString())
                .attr("aria-valuenow", value);
            self._hasScrollbar();
        },

        _wrapper: function () {
            var self = this,
                $element = self.element,
                DOMelement = $element[0],
                $wrapper;
            $wrapper = $element.parent();
            $element.removeClass(AVATAR);
            if (!$wrapper.is("span.k-widget"))
                $wrapper = $element.wrap("<span />").parent();
            // aria
            $wrapper
                .attr("tabindex", -1)
                .attr("role", "presentation");
            // styling
            $wrapper[0].style.cssText = DOMelement.style.cssText;
            self.wrapper = $wrapper
                .addClass("k-widget k-textarea k-header")
                .addClass(DOMelement.className)
                .removeClass("k-input");
            $element.removeClass("k-textarea");
        }

    });

    ui.plugin(TextArea);

})(window.kendo.jQuery);

/* ]]> */